module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.userAttributes), function(attribute) {
    return [(_vm.isVisible(attribute)) ? _c('user-attribute-chart', {
      attrs: {
        "userId": _vm.userId,
        "attribute": attribute
      }
    }) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-080589d7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/UserAttributeCharts.vue
// module id = 1169
// module chunks = 1